import * as React from 'react';
import { CareerLayout } from '../../components/CareerLayout/CareerLayout';
import { Hero } from './sections/Hero';
import { About } from './sections/About';
import { Products } from './sections/Products';
import { Teams } from './sections/Teams';
import { People } from './sections/People';
import { Vacancies } from './sections/Vacancies';
import { Offer } from './sections/Offer';
import { Values } from './sections/Values';
import { Architect } from './sections/Architect';
import { Blog } from './sections/Blog';

export const CareerContainer: React.FC = () => (
  <CareerLayout>
    <Hero />
    <About />
    <Products />
    <Teams />
    <People />
    <Vacancies />
    <Offer />
    <Values />
    <Architect />
    <Blog />
  </CareerLayout>
);
